<template>
    <comp-9-prep-adherence :section="9" :page="22" :next="nextScreen" :nextDisabled="nextDisabled">
        <p>
            So far, we’ve hit you up with a ton of information about educating and protecting yourself. We just want to take a moment to check in on how
            committed you are to this whole thing…
        </p>
        <p>
            How committed are you to doing what it takes to protect yourself from getting HIV?
        </p>
        <v-radio-group v-model="prepCommitmentSelection" column>
            <v-radio v-for="commitmentLevel in commitmentLevels" :key="commitmentLevel.id" :label="commitmentLevel.text" :value="commitmentLevel"></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepCommitmentSelection: null
        };
    },
    computed: {
        prepCommitmentLevel() {
            let selectedCommitmentLevel = find(this.commitmentLevels, 'selected');

            if (selectedCommitmentLevel) {
                return selectedCommitmentLevel;
            } else return null;
        },
        commitmentLevels: sync('section9/prepCommitment'),
        nextScreen() {
            if (this.prepCommitmentSelection) {
                return `/page/9/${this.prepCommitmentSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepCommitmentSelection;
        }
    },
    watch: {
        prepCommitmentSelection(newPrepCommitmentSelection) {
            forEach(this.commitmentLevels, o => {
                if (o.id === newPrepCommitmentSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepCommitmentSelection = this.prepCommitmentLevel;
    }
};
</script>
